import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography } from '@mui/material';
import React from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import DeleteIcon from '@mui/icons-material/Delete';

export type AlertDeletePropsType = {
  remove: () => void
  name: string
  deleteButtonText: string
}

export const AlertDelete = (props: AlertDeletePropsType) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseOnOK = () => {
    props.remove()
    setOpen(false);
  }

  return (
    <div>
      <Typography onClick={handleClickOpen} >
      <Button className='addItemButton' style={{ float: 'right', fontSize: '0.7rem' }} startIcon={<DeleteIcon style={{ color: 'grey' }} fontSize='medium' />}>
           {props.deleteButtonText}
          </Button>
          </Typography>
    
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Delete account
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete {props.name} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCloseOnOK} variant="contained" color="info" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}